import { Box, List, ListItem, Tooltip, Typography } from "@mui/material"

export const SingleQuestion = ({ question, order, phaseId, childDimension = 0 }) => {
	const hasChildQuestions = question.childQuestions.length > 0
	const isDate = (string) => {
		const regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{3})?Z$/
		return regex.test(string)
	}

	const toFinnishDate = (date) => {
		const d = new Date(date)
		return d.toLocaleDateString("fi-FI", {
			day: "numeric",
			month: "short",
			year: "numeric",
		})
	}
	const findAnswer = (question) => {
		const orderLines = order.orderlines.filter(
			(orderline) =>
				orderline.servicequestionid === question.servicequestionid && orderline.phaseid === parseInt(phaseId)
		)
		if (orderLines.length === 0) {
			return []
		} else if (orderLines.length === 1) {
			if (isDate(orderLines[0].answer)) {
				const dateOrderLines = orderLines.map((orderline) => {
					return {
						...orderline,
						answer: isDate(orderline.answer) ? toFinnishDate(orderline.answer) : orderline.answer,
					}
				})
				return dateOrderLines
			} else {
				return orderLines
			}
		}
		return orderLines
	}

	return (
		<Box>
			<Tooltip
				title={
					<Typography variant="h5">
						{findAnswer(question).length === 0 && "0 €"}
						{findAnswer(question).length === 1 && `${findAnswer(question)[0].costperunit} €`}
						{findAnswer(question).length > 1 &&
							`${findAnswer(question).reduce((acc, orderline) => acc + orderline.costperunit, 0)} €`}
					</Typography>
				}>
				<Box
					sx={(theme) => ({
						ml: childDimension,
						display: "flex",
						flexDirection: "row",
						cursor: "pointer",
						justifyContent: "space-between",
						":hover": { backgroundColor: theme.palette.primary.main },
					})}>
					<Typography variant="h5">{question.description}</Typography>
					<Typography variant="h5" sx={{ whiteSpace: "pre-line" }}>
						{findAnswer(question).length === 0 && "-"}
						{findAnswer(question).length === 1 && findAnswer(question)[0].answer}
						{findAnswer(question).length > 1 && (
							<List sx={{ p: 0 }}>
								{findAnswer(question).map((answer) => (
									<Tooltip
										title={<Typography variant="h6">{answer.costperunit ? answer.costperunit : 0} €</Typography>}
										followCursor
										key={answer.orderlineid}>
										<ListItem sx={{ p: 0, pl: 1, cursor: "pointer" }}>{answer.answer}</ListItem>
									</Tooltip>
								))}
							</List>
						)}
					</Typography>
				</Box>
			</Tooltip>
			{hasChildQuestions &&
				question.childQuestions.map((child) => (
					<SingleQuestion
						key={child.servicequestionid}
						question={child}
						order={order}
						childDimension={childDimension + 1}
						phaseId={phaseId}
					/>
				))}
		</Box>
	)
}
